<template>
  <div class="dialog-wrap">
    <el-dialog
      title="用户选择"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      :width="dialogWidth"
    >
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="用户名"
          prop="keyword"
        >
          <el-input
            v-model="query.keyword"
            size="mini"
            placeholder="输入昵称/姓名/手机号"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="报考院校"
          prop="college"
        >
          <el-input
            v-model="query.college"
            size="mini"
            placeholder="输入院校名称/代码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="报考专业"
          prop="major"
        >
          <el-input
            v-model="query.major"
            size="mini"
            placeholder="输入专业名称/代码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="分组"
          prop="category_id"
        >
          <el-select
            v-model="query.category_ids"
            size="mini"
            placeholder="请选择"
            @change="fetchMemberList"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in categorys"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="状态"
          prop="status"
        >
          <el-select
            style="width: 100px"
            v-model="query.status"
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in filter.status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="mini"
            @click="handleSearch"
          >搜索</el-button>
          <el-button
            class="submit"
            size="mini"
            @click="handleFormReset('searchForm')"
          >重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        class="result"
        ref="multipleTable"
        :data="results"
        tooltip-effect="dark"
        size="mini"
        max-height="500"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="nickname"
          label="昵称"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="realname"
          label="真实姓名"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号"
          min-width="160"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="category_ids"
          label="用户分组"
          min-width="160"
          align="center"
        >
          <template slot-scope="scope">
            {{renderCategoryName(scope.row.category_ids)}}
          </template>
        </el-table-column>
        <el-table-column
          label="考研年份"
          min-width="160"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.applicant ? scope.row.applicant.apply_year : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="报考院校"
          min-width="160"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ (scope.row.applicant && scope.row.applicant.college) ? scope.row.applicant.college.name : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="报考专业"
          min-width="160"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ (scope.row.applicant && scope.row.applicant.major) ? scope.row.applicant.major.name : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="注册时间"
          width="160"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{  $moment(scope.row.create_time).format('YYYY-MM-DD HH:mm')  }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == 1 ? 'success':'danger'">{{scope.row.status == 1 ? '正常' : '禁用'}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          background
          small
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500, 1000]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { memberList, memberCategoryList } from "@/api/member";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    users: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      query: {
        keyword: "",
        status: "",
        category_ids: [],
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1
      },
      pageTotal: 10,
      filter: {
        status: [
          { label: "全部", value: "" },
          { label: "正常", value: "1" },
          { label: "禁用", value: "0" }
        ]
      },
      categorys: [],
      results: [],
      selections: [],
      countSelections: [],
      dialogWidth: document.body.clientWidth < 820 ? '95%' : '980px',
      loading: false,
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;

      if (val) {
        this.fetchCategoryList();
        this.fetchMemberList();
      }
    },
    users(val) {
      this.countSelections = val
    }
  },
  methods: {
    // 用户列表请求
    fetchMemberList() {
      this.loading = true
      let params = {
        keyword: this.query.keyword,
        status: this.query.status,
        category_ids: this.query.category_ids.join(',') || "",
        pageIndex: this.query.pageIndex,
        pageSize: this.query.pageSize,
        isPaging: this.query.isPaging
      };

      memberList(params).then(res => {
        this.results = res.list || [];
        this.pageTotal = res.count;
        this.loading = false

        this.$nextTick(this.setRowSelection)
      });
    },
    // 分类列表请求
    fetchCategoryList() {
      memberCategoryList({ isPaging: 0 }).then(res => {
        let list = res.list
        list.unshift({ id: '', name: '全部' })
        this.categorys = res.list
      })
    },
    // 设置选中行
    setRowSelection() {
      if (this.results.length) {
        this.results.forEach(row => {
          if (this.users.find(item => item.id === row.id)) {
            this.$refs.multipleTable.toggleRowSelection(row, true)
          }
        })
      }
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchMemberList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchMemberList();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      this.fetchMemberList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchMemberList();
    },
    // 分类名称渲染
    renderCategoryName(ids) {
      if (!ids) {
        return ''
      }
      ids = ids.split(',')
      const list = this.categorys.filter(item => ids.includes(String(item.id)))
      if (list.length) {
        return list.map(v => v.name).join('、')
      }
      return ''
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        '1': '正常',
        '0': '禁用'
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    // 选择
    handleSelectionChange(val) {
      this.selections = val
      this.diffSelection()
    },
    // 选中项差异化计算
    diffSelection() {
      let diffs = []
      // 减
      this.countSelections.forEach((item, index) => {
        if (!this.selections.find(v => v.id === item.id)) {
          if (this.results.find(v2 => v2.id === item.id)) {
            diffs.push(item)
          }
        }
      })
      if (diffs.length) {
        this.countSelections = this.countSelections.filter(item => !diffs.find(v => v.id === item.id))
      }
      // 加
      this.selections.forEach(item => {
        if (!this.countSelections.find(v => v.id === item.id)) {
          this.countSelections.push(item)
        }
      })
    },
    handleSubmit() {
      this.$emit("submit", { users: this.countSelections })
      this.handleClose();
    },
    handleClose() {
      // 检索条件重置
      this.query = {
        keyword: "",
        type: "",
        status: "",
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
        category_ids: [],
      };
      this.$emit("close")
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-wrap {
  .search-wrap {
    margin-bottom: -8px;

    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
      margin-bottom: 10px;
    }
  }
  .result {
    margin-top: 10px;
  }
  .footer {
    margin-top: 10px;
  }
}
</style>
